/**
 * @flow
 * @relayHash a24f4caff72182b585ecf57772cc2aa0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReactionButtonQueryVariables = {||};
export type ReactionButtonQueryResponse = {|
  +reactionByOrg: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +color: string,
      |}
    |}>
  |}
|};
export type ReactionButtonQuery = {|
  variables: ReactionButtonQueryVariables,
  response: ReactionButtonQueryResponse,
|};
*/


/*
query ReactionButtonQuery {
  reactionByOrg {
    edges {
      node {
        id
        name
        color
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "reactionByOrg",
    "storageKey": null,
    "args": null,
    "concreteType": "ReactionDefinitionNodeConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "ReactionDefinitionNodeEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "ReactionDefinitionNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "color",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReactionButtonQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ReactionButtonQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ReactionButtonQuery",
    "id": null,
    "text": "query ReactionButtonQuery {\n  reactionByOrg {\n    edges {\n      node {\n        id\n        name\n        color\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6a61fa79bd545d4d7e35be4693696d84';
module.exports = node;
